<div class="container-lottie" [hidden]="isLoading != true">
    <div id="lottie"></div>
  </div>